import { FC } from 'react';

import { PrivacyTermsType, PrivacyTermsSubMenuType } from '@/types';

interface IPrivacyTermsProps {
  privacyTerms: PrivacyTermsType[];
}

const PrivacyTerms: FC<IPrivacyTermsProps> = ({ privacyTerms }) => {
  return (
    <div className="">
      {privacyTerms.map(
        ({ id, privacyTermsSubMenu, privacyTermsText }: PrivacyTermsType) => (
          <div key={id} className="">
            {privacyTermsText && (
              <p className="mb-4 custom-p ">{privacyTermsText}</p>
            )}
            {privacyTermsSubMenu && (
              <ul className=" marker:text-black list-decimal m-0 px-[10%]">
                {privacyTermsSubMenu.map(
                  ({ title, text }: PrivacyTermsSubMenuType, id) => (
                    <li key={id}>
                      <p className="mb-4">{title}</p>
                      <p className="mb-4 custom-p ">{text}</p>
                    </li>
                  )
                )}
              </ul>
            )}
          </div>
        )
      )}
    </div>
  );
};

export default PrivacyTerms;
